{
  "auth.login.otp.email.back.button_label": "Voltar",
  "auth.login.otp.email.cancel.button_label": "Cancelar",
  "auth.login.otp.email.continue.button_label": "Continuar",
  "auth.login.otp.email.error_format": "Insira um e-mail válido",
  "auth.login.otp.email.forgot_password.link_text": "Esqueceu a senha? Entre com código de acesso",
  "auth.login.otp.email.form.label": "E-mail",
  "auth.login.otp.email.form.placeholder": "E-mail",
  "auth.login.otp.email.passcode.form.helper_text": "Digite o código enviado para",
  "auth.login.otp.email.passcode.form.label": "Código",
  "auth.login.otp.email.passcode.form.placeholder": "Código",
  "auth.login.otp.email.passcode.helper_text": "Enviaremos um código por e-mail para confirmar seu endereço.",
  "auth.login.otp.email.passcode.resend.link_text": "Não recebeu o e-mail? Reenviar código",
  "auth.login.otp.email.passcode.resend.link_text.resending": "Reenviando...",
  "auth.login.otp.email.passcode.switch_method.link_text": "Enviar código para o número de telefone em vez disso",
  "auth.login.otp.email.password.label": "Senha",
  "auth.login.otp.email.password.placeholder": "Senha",
  "auth.login.otp.email.password.required": "A senha é obrigatória"
}
